import { useContext, useState } from "react"
import { toast } from 'react-hot-toast';
import Loader from "../Common/Loader";
import SystemModal from "../Common/SystemModal";
import ajaxUser from "../../util/remote/ajaxUser";
import SchoolContext from "../../Context/SchoolContext";
import Select from "react-select";

const UpdateSchool=(props)=>{

    const [loading, setLoading] = useState(false)
    const [school,setSchool] =useState("")
    const {schoolList} = useContext(SchoolContext);

    const handleUpdate = async(e) =>{
        e.preventDefault()
        if(school.length>0){
            setLoading(true)
            const server_response = await ajaxUser.updateSchool(props.adminID, school);
            setLoading(false);
            if(server_response.status==="OK"){
                toast.success(server_response.message);
                props.g()
            }
            else{
                toast.error(server_response.message); 
            }
        }
        else{
            toast.error("Please enter all fields!")
        }  
    }
    

    const RenderFooter=(controls)=>{

        if(loading){
            return <Loader/>
        }else{

            return <> 
                <button className="btn-fill-md text-light bg-martini shadow-martini" type="button" onClick={controls.close}>Close</button>
                <button 
                    type="button" 
                    className={`btn-fill-md text-light bg-dodger-blue`} 
                    onClick={handleUpdate}>Save Changes<i class="fas fa-check mg-l-15"></i>
                </button>
            </>
        }
    }

    return(
        <SystemModal
            title="Change School"
            id="model-new-sch"
            size="md"
            footer={RenderFooter}
        >
            <div className="row">
            <div className="mb-4 col-12 form-group">
            <label htmlFor="">School <span style={{color:"red"}}>*</span></label>
                    <Select
                      onChange={(e) => setSchool(e.school_id)}
                      getOptionLabel={(option) => option.school_name}
                      getOptionValue={(option) => option.school_id}
                      isSearchable
                      options={Array.isArray(schoolList) ? schoolList : []}
                      value={
                        Array.isArray(schoolList) &&
                        schoolList.find((value) => value.school_id === school)
                      }
                    />
            </div>
            </div>
       
        </SystemModal>
    )
}

export default UpdateSchool
